export type TNativeAnalyserNode = AnalyserNode;
